import Vue from "vue"
import VueI18n from "vue-i18n"
import getLocale from "@/utils/locale"
import StayPage from "./components/stay-page"
import store from "@/store/"

const id = "vue-stay"

export default () => {
  const el = document.querySelector(`#${id}`)

  if (!el) {
    return
  }

  const { i18nKey, hasDiscount, churnSurveyOption, subscriptionType, subscriptionRenewalDate } = el.dataset

  const vm = new Vue({
    name: "StayPageWrapper",
    store,
    i18n: new VueI18n({ locale: getLocale() }),
    render: (h) =>
      h(StayPage, {
        props: {
          churnSurveyOption,
          i18nKey,
          hasDiscount: hasDiscount === "true",
          subscriptionType,
          subscriptionRenewalDate
        }
      })
  })

  vm.$mount(el)
}
